import { Injectable } from '@angular/core';
import { Store } from '../../core/services/store.service';

@Injectable({
  providedIn: 'root',
})
export class OnboardingStoreService extends Store<IOnboardingState> {

  constructor() {
    super({
      finishScreenSeen: localStorage.finishScreenSeen || true,
      finished: localStorage.finished || true,
      skipped: localStorage.skipped || true,
      step: localStorage.step || 'WELCOME',
    }, 'onboardingState');
  }

  get finished(): boolean {
    return this.state.finished;
  }

  get skipped(): boolean {
    return this.state.skipped;
  }

  get active(): boolean {
    return !this.finished && !this.skipped;
  }

  public continue(step: OnboardingStep): void {
    this.setState({ ...this.state, finished: false, skipped: false });
    this.setStep(step);
  }

  public finish(): void {
    this.setState({ ...this.state, finished: true, step: 'FINISHED' });
  }

  public skip() {
    this.setState({ ...this.state, skipped: true });
  }

  public sawFinishScreen(): void {
    this.setState({ ...this.state, finishScreenSeen: true });
    this.finish();
  }

  public setStep(step: OnboardingStep): void {
    this.setState({ ...this.state, step });
  }

  public changeStep(step: OnboardingStep): void {
    this.setState({ ...this.state, step });
  }


  public shouldNavigate(): boolean {
    return this.state && this.active;
  }

  public step(): OnboardingStep {
    return this.state.step;
  }
}

export interface IOnboardingState {
  finished: boolean;
  skipped: boolean;
  step: OnboardingStep;
  finishScreenSeen: boolean;
}

export type OnboardingStep = 'WELCOME' | 'SAVED_NICK' | 'FINISHED';
